import {Alert} from 'react-bootstrap'
import {ClientListEdge, SaleproductthroughSetEdge} from '../../graphql/types/ventasType'
import {parsePrice} from '../../helpers'

interface IAlertProps {
  products: {
    product: string
    quantity: string
  }[]
  clientData: ClientListEdge[]
  client: {
    value: string
    label: string
    isDisabled?: boolean
  }
  allProducts: SaleproductthroughSetEdge[]
}

export const AlertDispatchNoSales: React.FC<IAlertProps> = ({
  client,
  clientData,
  products,
  allProducts,
}) => {
  const {value} = client
  const idClient = value.split('***')[0]
  const findClient = clientData.find(({node}) => node.id === idClient)

  if (!findClient) {
    return <Alert>No se pudo visualizar el resumen del despacho</Alert>
  }

  let totalGeneral = 0

  return (
    <Alert variant='dark'>
      <Alert.Heading className='text-center fs-1'>RESUMEN</Alert.Heading>
      <div>
        {products.map(({product, quantity}, idx) => {
          const idProduct = product.split('***')[0]
          const findProd = findClient.node.clientproductpriceSet.edges.find(
            ({node}) => node.product.id === idProduct
          )

          let totPay = 0
          let content: JSX.Element | null = null

          if (!findProd) {
            const findProdNotClient = allProducts.find(({node}) => node.id === idProduct)
            if (!findProdNotClient) {
              return (
                <p key={idProduct} className='text-danger'>
                  No se encontró el producto con ID {idProduct}
                </p>
              )
            }

            totPay =
              Number(quantity) *
              (Number(findProdNotClient.node.product.unitPrice) -
                Number(findProdNotClient.node.product.promotion))

            if (totPay <= 0) return null

            content = (
              <>
                <p className='fs-3'>
                  <span className='fw-bold me-2'>Precio público</span>
                  <span>{parsePrice(findProdNotClient.node.product.unitPrice)}</span>
                </p>
                {Boolean(Number(findProdNotClient.node.product.promotion)) && (
                  <>
                    <p className='fs-4'>
                      <span className='fw-bold text-info me-2'>¡Tiene descuento de</span>
                      <span className='text-info'>
                        {parsePrice(findProdNotClient.node.product.promotion)}!
                      </span>
                    </p>
                    <p className='fs-3 my-4'>
                      <span className='fw-bold me-2'>Precio total unitario</span>
                      <span>
                        {parsePrice(
                          `${
                            Number(findProdNotClient.node.product.unitPrice) -
                            Number(findProdNotClient.node.product.promotion)
                          }`
                        )}
                      </span>
                    </p>
                  </>
                )}
              </>
            )
          } else {
            const hasDiscount = Boolean(Number(findProd.node.product.promotion))
            const realPricesProds =
              Number(findProd.node.price) - Number(findProd.node.product.promotion)
            totPay = Number(quantity) * Number(realPricesProds)

            if (totPay <= 0) return null

            content = (
              <>
                <p className='fs-3' style={{textDecoration: 'line-through'}}>
                  <span className='fw-bold me-2'>Precio público</span>
                  <span>{parsePrice(findProd.node.product.unitPrice)}</span>
                </p>
                <p className='fs-3 my-4'>
                  <span className='fw-bold me-2'>Precio cliente</span>
                  <span>{parsePrice(findProd.node.price)}</span>
                </p>
                {hasDiscount && (
                  <>
                    <p className='fs-4'>
                      <span className='fw-bold text-info me-2'>¡Tiene descuento de</span>
                      <span className='text-info'>
                        {parsePrice(findProd.node.product.promotion)}!
                      </span>
                    </p>
                    <p className='fs-3 my-4'>
                      <span className='fw-bold me-2'>Precio total unitario</span>
                      <span>{parsePrice(`${realPricesProds}`)}</span>
                    </p>
                  </>
                )}
              </>
            )
          }

          totalGeneral += totPay

          return (
            <div key={idProduct} className='mb-4'>
              <h5 className='fw-bold'>Producto: {product.split('***')[1]}</h5>
              <h5 className='fw-bold'>Cantidad: {quantity}</h5>
              {content}
              <p className='text-left fs-4 fw-bold text-uppercase'>
                <span className='me-4 text-danger'>Total:</span>
                <span className='text-dark'>{parsePrice(`${totPay}`)}</span>
              </p>
              {products.length === idx + 1 ? null : <hr />}
            </div>
          )
        })}

        <hr />
        <p className='text-center fs-1 fw-bold text-uppercase'>
          <span className='me-4 text-success'>Total General:</span>
          <span className='text-dark'>{parsePrice(`${totalGeneral}`)}</span>
        </p>
      </div>
    </Alert>
  )
}
